import styled from 'styled-components'
import { ThemeProps } from 'src/hook/useUser'

export const Title = styled.h2`
  font-size: 1.125rem;
`

Title.displayName = 'Title'

type HeaderProps = {
  theme: ThemeProps
}

export const Header = styled.header<HeaderProps>`
  background-color: ${({ theme }) => (theme === 'dark' ? '#0e0f12' : 'var(--white)')};
  top: 0;
  z-index: 1;
`

Header.displayName = 'Header'
